import { Line, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;
export default {
  extends: Line,
  mixins: [reactiveProp],
  props: ["chartData", "options"],
  data: () => ({
    interval: null,
  }),
  mounted() {
    console.log(this.chartData);
    this.renderChart(this.chartData, this.options);
    this.interval = setInterval(() => {
      if (this.$data._chart) {
        // this.$data._chart.options.scales.yAxes[0].ticks.max =
        //   this.options.scales.yAxes[0].ticks.max;
        // this.$data._chart.options.scales.yAxes[0].ticks.min =
        //   this.options.scales.yAxes[0].ticks.min;
        this.$data._chart.options =  this.options
        this.$data._chart.update();
      }
    }, 2000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
};
